import { render, staticRenderFns } from "./ReservasCandidatos.vue?vue&type=template&id=24cdd191&"
import script from "./ReservasCandidatos.vue?vue&type=script&lang=js&"
export * from "./ReservasCandidatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports